/**
 * @file Input component for signature input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { InputBase } from '../input-base/input-base';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
/**
 * Class for the signature input component
 */
var InputSignatureComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputSignatureComponent, _super);
    /**
     * Constructs a Signature Input
     * @param elementRef Reference to the component (in DOM)
     */
    function InputSignatureComponent(elementRef, changeDetectorRef) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.changeDetectorRef = changeDetectorRef;
        // Keep track of the signature data
        _this.rawSignatureData = '';
        return _this;
    }
    /** Lifecycle hook that is called after a component's view has been fully initialized. */
    InputSignatureComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.canvasContainer = this.elementRef.nativeElement.querySelector('.sym-canvas-container');
        this.canvasSignature = this.elementRef.nativeElement.querySelector('canvas');
        this.setCanvasSize();
        this.changeDetectorRef.detectChanges();
        setTimeout(function () {
            _this.setRawSignatureData(_this.value);
        });
        // Handles the change (outside this component) of value
        this.subscriptionPool.add(this.valueChange.subscribe(function (value) {
            // Fix issue: Error bij zetten handtekening in werkbon #2606
            // Geen relead behalve bij clearSignature
            // signaturePad.clear() in loadSignature gaf issue #2606
            _this.setRawSignatureData(value, value === '');
            _this.loadSignature();
        }));
    };
    /**
     * When the window is resized this event is called
     */
    InputSignatureComponent.prototype.setCanvasSize = function () {
        // Calculate new width and height based on the parent
        var newWidth = this.canvasContainer.clientWidth;
        var newHeight = this.canvasContainer.clientWidth * 0.5;
        if (this.oldWidth !== newWidth || this.oldHeight !== newHeight) {
            this.oldWidth = newWidth;
            this.oldHeight = newHeight;
            // Set display size (css pixels).
            this.signaturePad.set('canvasWidth', newWidth); // Updates the property 'width' of the canvas
            this.signaturePad.set('canvasHeight', newHeight); // Updates the property 'height' of the canvas
            this.canvasSignature.style.width = newWidth + 'px';
            this.canvasSignature.style.height = newHeight + 'px';
            // Resize based on correct ratio
            this.signaturePad.resizeCanvas();
            // this.ratio = Math.max(window.devicePixelRatio || 1, 1);
            // this.canvasSignature.width = newWidth;
            // this.canvasSignature.height = newHeight;
            // this.canvasSignature.style.width = newWidth;
            // this.canvasSignature.style.height = newHeight;
            // this.canvasSignature.getContext('2d').scale(ratio, ratio);
            // Clear the signature canvas and reload content
            this.loadSignature();
        }
    };
    /**
     * Set the lcoal raw signature data and perform a load signature call
     */
    InputSignatureComponent.prototype.setRawSignatureData = function (value, reload) {
        if (reload === void 0) { reload = true; }
        if (value && value.length > 0) {
            this.rawSignatureData = value;
        }
        else {
            this.rawSignatureData = '';
        }
        if (reload) {
            this.loadSignature();
        }
    };
    /**
     * Check if there is a signature in the canvas
     */
    InputSignatureComponent.prototype.hasSignature = function () {
        return (this.rawSignatureData && this.rawSignatureData.length > 0);
        // return (this.signatureData.length > 0);
    };
    /**
     * Clear both the canvas and value
     */
    InputSignatureComponent.prototype.clearSignature = function () {
        this.rawSignatureData = '';
        this.customSetValue(this.rawSignatureData);
    };
    /**
     * After setting the new value alwasy emit an event even
     * if the reference is the same.
     */
    InputSignatureComponent.prototype.customSetValue = function (value) {
        this.setValue(value);
        this.valueChange.emit(value);
    };
    /**
     * Load the signature data
     */
    InputSignatureComponent.prototype.loadSignature = function () {
        this.signaturePad.clear();
        if (this.rawSignatureData && this.rawSignatureData.length > 0) {
            this.signaturePad.fromDataURL(this.rawSignatureData);
        }
    };
    /**
     * After finishing a drawing this function is called to
     * store the signature as a value.
     */
    InputSignatureComponent.prototype.drawComplete = function () {
        this.rawSignatureData = this.signaturePad.toDataURL();
        // this.signaturePad.clear();
        this.customSetValue(this.rawSignatureData);
    };
    return InputSignatureComponent;
}(InputBase));
export { InputSignatureComponent };
